import IllustrationComponent from './illustration';

export default IllustrationComponent;